(function(){
  function ready(fn){ if(document.readyState!='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function(){
    document.querySelectorAll('.mhp-lp').forEach(function(root){
      // Flavor selector
      var flavorBtns = root.querySelectorAll('[data-mhp-flavor]');
      var preview = root.querySelector('[data-mhp-preview]');
      var flavorData = {};
      flavorBtns.forEach(function(btn){
        var id = btn.getAttribute('data-mhp-flavor');
        flavorData[id] = {
          name: btn.getAttribute('data-name'),
          sub: btn.getAttribute('data-sub') || '',
          price: btn.getAttribute('data-price'),
          strike: btn.getAttribute('data-strike') || '',
          img: btn.getAttribute('data-img'),
          img2: btn.getAttribute('data-img2') || '',
          tag: btn.getAttribute('data-tag') || '',
          featured: btn.getAttribute('data-featured') === 'true'
        };
        btn.addEventListener('click', function(){
          flavorBtns.forEach(function(b){ b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          updatePreview(id);
        });
      });
      function updatePreview(id){
        if(!preview) return;
        var d = flavorData[id]; if(!d) return;
        var imgWrap = preview.querySelector('[data-mhp-img]');
        if(d.featured && d.img2){
          imgWrap.innerHTML = '<div style="display:flex;width:100%;justify-content:center;align-items:center;"><img src="'+d.img+'" alt="" style="width:45%;max-width:220px;transform:rotate(-6deg);"><img src="'+d.img2+'" alt="" style="width:45%;max-width:220px;margin-left:-24px;transform:rotate(6deg);"></div>';
        } else {
          imgWrap.innerHTML = '<img src="'+d.img+'" alt="'+d.name+'">';
        }
        preview.querySelector('[data-mhp-tag]').textContent = d.tag;
        preview.querySelector('[data-mhp-name]').textContent = d.name;
        var subEl = preview.querySelector('[data-mhp-sub]');
        subEl.textContent = d.sub; subEl.style.display = d.sub ? '' : 'none';
        preview.querySelector('[data-mhp-price]').textContent = d.price;
        var strikeEl = preview.querySelector('[data-mhp-strike]');
        strikeEl.textContent = d.strike; strikeEl.style.display = d.strike ? '' : 'none';
      }

      // FAQ toggle
      root.querySelectorAll('[data-mhp-faq]').forEach(function(faq){
        var btn = faq.querySelector('.mhp-faq-btn');
        btn.addEventListener('click', function(){ faq.classList.toggle('is-open'); });
      });
    });
  });
})();
